import React from 'react'

const MFRankSkeleton = () => {
  return (
    <div className='flex flex-col w-full pb-[24px]'>
      <div className='flex justify-between'>
        <div className='flex flex-col'>
          <div className='skeleton w-[150px] h-[18px] mb-[2px] rounded-[4px]' />
          <div className='flex gap-[4px] text-[#3D3D3D] pb-4'>
            <div className='skeleton w-[60px] h-[14px] rounded-[4px]' />
            <div className='skeleton w-[100px] h-[14px] rounded-[4px]' />
          </div>
        </div>
        <div className='flex flex-col'>
          <div className='skeleton w-[50px] h-[14px] rounded-[12px]' />
        </div>
      </div>
      <hr className='opacity-[0.1]' />

      <div className='flex flex-col'>
        <div className='skeleton w-[80px] h-[12px] mb-2 mt-4 ml-1 rounded-[12px]' />
        <div className='skeleton w-full h-[250px] rounded-[12px]' />
      </div>
      <div className='flex gap-3 pt-4'>
        <div className='flex-1'>
          <div className='flex gap-[8px]'>
            <div className='skeleton w-[40px] h-[30px] rounded-[12px]' />
            <div className='skeleton w-[40px] h-[30px] rounded-[12px]' />
            <div className='skeleton w-[40px] h-[30px] rounded-[12px]' />
          </div>
        </div>
        <div>
          <div className='skeleton w-[85px] h-[36px] rounded-[12px]' />
        </div>
        <div className='w-[38px]'>
          <div className='skeleton w-[38px] h-[38px] rounded-[12px]' />
        </div>
      </div>
    </div>
  )
}

export default MFRankSkeleton
